import axios from 'axios';

async function listNotifications() {
  const response = await axios.get('/notifications');

  return response.data;
}

async function updateNotifications(data) {
  const response = await axios.put('/notifications', data);

  return response.data;
}

const notificationService = {
  listNotifications,
  updateNotifications,
}

export default notificationService;
